import { getLocationsSimple, getOrgLocation, getOrgLocations } from '@libs/api/settings';
import { LocationExtra, LocationShort } from '@libs/models/locations';
import { create } from 'zustand';
import { getLocations } from '@libs/api/locations';
import { LocationList } from '@libs/models/locations';

type State = {
  loading: boolean;
  initiated: boolean;
  currentInitiated: boolean;
  locations: LocationList[];

  initiatedSimple: boolean;
  loadingSimple: boolean;
  locationsSimple: LocationShort[];

  currentLocationLoading: boolean;
  currentLocationID: string;
  current: LocationExtra | null;
  loadLocations: (options?: { force?: boolean }) => void;
  loadSimple: () => void;
  setCurrentLocation: (id: string) => void;
  reloadCurrentLocation: (isSilent: boolean) => void;
};

const LS_CURRENT_LOCATION_KEY = 'userdata:locationSelection';

export const useLocationStore = create<State>()((set, get) => ({
  loading: false,
  initiated: false,
  currentInitiated: false,
  locations: [],

  initiatedSimple: false,
  loadingSimple: false,
  locationsSimple: [],

  currentLocationLoading: false,
  current: null,
  currentLocationID: '',

  loadSimple: async () => {
    set({ loadingSimple: true });
    try {
      const resp = await getLocationsSimple();
      const currentLocID = localStorage.getItem(LS_CURRENT_LOCATION_KEY);
      set({
        loadingSimple: false,
        locationsSimple: resp.data,
        currentLocationID: currentLocID ?? resp.data[0].id,
        currentInitiated: true,
        initiatedSimple: true,
      });
    } finally {
      set({ loadingSimple: false });
    }
  },

  loadLocations: async (options) => {
    const { force } = options || {};
    if (get().initiated && !force) {
      // Locations are already loaded and it is very small chance that they will change while app is running
      // We use locations in a lot of places,
      // so we want to avoid reloading them to prevent rendering in unexpected places
      return;
    }
    try {
      set({ loading: true });
      const { data } = await getLocations();

      set({ locations: data.data, initiated: true });
    } finally {
      set({ loading: false });
    }
  },

  reloadCurrentLocation: async (isSilent) => {
    const { currentLocationID: id } = get();
    if (!id) {
      return;
    }

    !isSilent && set({ loading: true });
    try {
      const resp = await getOrgLocation(id);
      !isSilent && set({ loading: false });
      set({
        current: resp,
      });
    } finally {
      !isSilent && set({ loading: false });
    }
  },

  setCurrentLocation: async (id) => {
    if (!id) {
      return;
    }
    set({ loading: true });
    localStorage.setItem(LS_CURRENT_LOCATION_KEY, id);
    try {
      const resp = await getOrgLocation(id);
      set({
        loading: false,
        current: resp,
        currentLocationID: resp.id,
      });
    } finally {
      set({ loading: false });
    }
  },
}));
